import { AlertCircle, Home, RefreshCw } from "lucide-react";

const ErrorAlert = ({ error, onRetry }) => {
  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-3"
      style={{
        backgroundColor: "var(--bg-color)",
        fontFamily: "var(--default-font)",
      }}
    >
      <div
        className="card border-0"
        style={{
          maxWidth: "600px",
          width: "100%",
          boxShadow: "var(--shadow-4)",
          borderRadius: "var(--rounded-16)",
          backgroundColor: "var(--white)",
        }}
      >
        <div className="card-body p-5">
          <div className="text-center mb-4">
            <div className="mb-4">
              <AlertCircle
                size={72}
                style={{ color: "var(--danger-main)" }}
                strokeWidth={1.5}
              />
            </div>
            <h6
              className="fw-bold mb-3"
              style={{
                color: "var(--danger-main)",
                fontSize: "var(--font-2xl)",
              }}
            >
              Something Went Wrong
            </h6>
            <div
              className="alert mb-4 border-0"
              role="alert"
              style={{
                // backgroundColor: "var(--danger-50)",
                color: "var(--danger-700)",
                // borderRadius: "var(--rounded-12)",
                padding: "var(--size-20)",
              }}
            >
              <p className="mb-0" style={{ fontSize: "var(--font-md)" }}>
                { "Please Check Your Network Connection."}
              </p>
            </div>
          </div>

          <div className="d-grid gap-3 mt-2 mb-5">
            <div className="d-flex align-items-center justify-content-center">
              <button
                className="btn d-flex align-items-center justify-content-center gap-3 border-0"
                onClick={()=>window.location.reload()}
                style={{
                  backgroundColor: "var(--brand)",
                  color: "white",
                  borderRadius: "var(--rounded-12)",
                  padding: "var(--size-16) var(--size-24)",
                  fontSize: "var(--font-md)",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "var(--primary-700)")
                }
                onMouseOut={(e) =>
                  (e.target.style.backgroundColor = "var(--brand)")
                }
              >
                <RefreshCw size={24} />
                <span>Retry</span>
              </button>
            </div>
            {/* <button
              className="btn btn-lg d-flex align-items-center justify-content-center gap-2"
              style={{
                backgroundColor: "transparent",
                color: "var(--text-secondary-light)",
                border: "1px solid var(--border-color)",
                borderRadius: "var(--rounded-12)",
                padding: "var(--size-16) var(--size-24)",
                fontSize: "var(--font-md)",
                fontWeight: "500",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "var(--neutral-50)";
                e.target.style.color = "var(--text-primary-light)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "var(--text-secondary-light)";
              }}
              
            >
              <Home size={20} />
              <span>Go Back</span>
            </button> */}
          </div>

          <div
            className="mt-4 pt-4 text-center"
            style={{
              borderTop: "1px solid var(--border-color)",
            }}
          >
            <small
              style={{
                color: "var(--text-secondary-light)",
                fontSize: "var(--font-sm)",
              }}
            >
              If the problem persists, please contact support
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;
